import React from 'react'

const WPrivacyPolicy = () => {
  return (
     <main className="main">
      <section className="serv-comp">
        <div className="common-container">
          <div className="comn-heading">
            <h3>
              Privacy <span>Policy</span>{" "}
            </h3>

            <p>
              At Nikah-e-Muslim, we are committed to protecting your privacy and
              safeguarding your personal information. This Privacy Policy
              explains how we collect, use, store, and protect your data when
              you use our website and mobile application.
            </p>

            <p>
              We collect personal information such as name, age, gender,
              contact details, religious preferences, family information, and
              profile details to provide matchmaking services. This information
              is used solely to improve compatibility, enhance user experience,
              and facilitate meaningful connections for Nikah purposes.
            </p>

            <p>
              Your profile information is visible only according to your
              privacy settings. You have full control over who can view your
              photos and personal details. Sensitive data such as contact
              numbers and private chats are never shared publicly.
            </p>

            <p>
              Nikah-e-Muslim uses industry-standard security measures to protect
              your data from unauthorized access, misuse, or disclosure.
              However, while we strive to protect your information, no online
              platform can guarantee absolute security.
            </p>

            <p>
              We do not sell, rent, or trade your personal information to third
              parties. Your data may only be shared with trusted service
              providers when required for essential platform operations such as
              payments, notifications, or technical support.
            </p>

            <p>
              Cookies and similar technologies may be used to improve site
              performance, personalize content, and analyze user behavior. You
              can manage or disable cookies through your browser settings.
            </p>

            <p>
              By using Nikah-e-Muslim, you agree to this Privacy Policy. We may
              update this policy from time to time, and any changes will be
              posted on this page. Continued use of the platform indicates your
              acceptance of the updated policy.
            </p>

            <p>
              If you have any questions or concerns regarding your privacy, you
              may contact us through our official support channels.
            </p>
          </div>
        </div>
      </section>
    </main>
  )
}

export default WPrivacyPolicy
